import { render } from "./reportEatOverTimeFood.vue?vue&type=template&id=efee67f2"
import script from "./reportEatOverTimeFood.vue?vue&type=script&lang=js"
export * from "./reportEatOverTimeFood.vue?vue&type=script&lang=js"

import "./reportEatOverTimeFood.vue?vue&type=style&index=0&id=efee67f2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__